<template>
  <legend
    :class="['zg-input-legend', {
      'zg-input-legend--has-tooltip-trigger': tooltip && !disabled && (forceTooltipTrigger || tooltip.trigger)
    }]"
  >
    <slot />

    <span
      v-if="required"
      class="is-required"
    >
      *
    </span>

    <span
      v-if="valid"
      class="is-valid"
    >
      <zg-icon icon="valid" />
    </span>

    <zg-tooltip
      v-if="tooltip && !disabled"
      :title="tooltip.title"
      :text="tooltip.text"
      :direction="tooltip.direction"
      :visible="focused"
      :hide-trigger="!forceTooltipTrigger && !tooltip.trigger"
      input
    />
  </legend>
</template>

<script>
  import ZgIcon from '../ZgIcon/ZgIcon'
  import ZgTooltip from '../ZgTooltip/ZgTooltip.vue'

  export default {
    name: 'ZgInputLegend',
    components: {
      ZgIcon,
      ZgTooltip
    },
    props: {
      tooltip: {
        type: Object,
        required: false,
        default: null
      },
      forceTooltipTrigger: {
        type: Boolean,
        required: false,
        default: false
      },
      required: {
        type: Boolean,
        required: false,
        default: false
      },
      valid: {
        type: Boolean,
        required: false,
        default: false
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false
      },
      focused: {
        type: Boolean,
        required: false,
        default: false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .zg-input-legend {
    @include type-title-s;

    position: relative;
    display: inline-flex;
    gap: rem(4px);
    width: 100%;
    color: color(black);
    margin: 0 0 rem(16px);

    &--has-tooltip-trigger {
      padding-right: input(tooltip-width);
    }

    .is-required {
      @include type-body-m;

      color: color(error-500);
      margin: 0;
    }

    .is-valid {
      display: inline-flex;
      align-items: center;

      ::v-deep svg {
        color: color(success-500);
        width: rem(16px);
        height: rem(16px);
      }
    }
  }
</style>
